import type { TourDef } from './index';

const a = (id: string): string => `[data-tour="${id}"]`;

export const businessTour: TourDef = {
  id: 'business',
  steps: [
    { element: a('invoice-new'), popover: { title: 'Invoices and bills', description: 'Line items with GST worked out for you. Mark them sent, then record the payment when it arrives.' } },
    { element: a('business-gst'), popover: { title: 'GST as you go', description: 'This year’s GST on sales and credits, ready for your BAS.' } },
  ],
};
